import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { generateCognitoPhoneFormat } from '../../CustomerPortalUtil';
import { AvantoCognitoService } from 'src/app/services/avanto-cognito.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-confirm-verification-code',
  templateUrl: './confirm-verification-code.component.html',
  styleUrls: [
    '../../../../../../../node_modules/daemonite-material/css/material.min.css',
    '../customer-authentication.component.scss'
  ]
})
export class ConfirmVerificationCodeComponent implements OnInit {

  @Input() userPhoneNumber: string;
  @Output() confirmVerificationSuccess = new EventEmitter();
  @Output() confirmVerificationFailure = new EventEmitter();
  @Output() newUserLoginIsMissing = new EventEmitter();

  verificationCode: string

  constructor(private cognito: AvantoCognitoService) { }

  ngOnInit() {
    if (this.userPhoneNumber == null || this.userPhoneNumber == "") {
      Swal.fire({ type: 'error', title: 'Something went wrong. Please, try signing up again.' })
      this.newUserLoginIsMissing.emit();
    }
  }

  cancel(){
    this.confirmVerificationFailure.emit()
  }

  confirm() {
    this.cognito.confirmSignUp(generateCognitoPhoneFormat(this.userPhoneNumber), this.verificationCode)
      .then((response) => {
        this.confirmVerificationSuccess.emit();
      })
      .catch((err) => {
        if (err == "INVALID_INPUT") {
          //If you are getting this, you, the developer, has done something wrong!
          Swal.fire({ type: 'error', title: 'Could not verify your phone number. Try again later.' })
        } else {
          Swal.fire({ type: 'error', title: err.message })
        }
      });
  }
}
